import { preload } from './modules/mod_preload'
import { navigation } from './modules/mod_navigation'
import { slider } from './modules/mod_slider' // perspektivisch durch splide ersetzen
import { lightbox } from './modules/mod_lightbox'
import { scrollToTop } from './modules/mod_scrollToTop'

window.addEventListener('load', () => {
	preload()
	navigation()
	slider()
	lightbox()
	scrollToTop()
})
